module.exports = __webpack_public_path__ + "static/minsu.kim-35caaef385212c66ce2ae34865728805.png";